module.exports = {"511771001":"斌郎街道","511771002":"石板街道","511771100":"河市镇","511771101":"金垭镇","511771201":"幺塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511771.json
// module id = 2509
// module chunks = 0